<template>
    <div>
        <nav class="site-navbar" :class="'site-navbar--' + navbarLayoutType">
            <div class="site-navbar__header">
                <h1 class="site-navbar__brand" style="vertical-align: middle;">
                    <a class="site-navbar__brand-lg" href="javascript:;">
                        <img height="30px" width="30px" src="../assets/img/logo.png"
                             style="width: auto;padding-right: 5px;margin-left:-15px;margin-bottom: 5px;">
                        云算盘
                    </a>
                </h1>
            </div>
            <div class="" style="float: left; margin-left: 50px;">
                <MainSidebar></MainSidebar>
            </div>
            <div class="site-navbar__body clearfix">
                <el-menu class="site-navbar__menu site-navbar__menu--right" mode="horizontal">
                    <el-menu-item index="1" v-if="messageFlag">
                        <el-badge :value="1" class="item" size="small">
                            <el-button size="small" @click="openMessage">消息</el-button>
                        </el-badge>
                    </el-menu-item>

                    <el-menu-item>
                        <el-tooltip :content="isFullscreen ? '取消全屏' : '全屏'" placement="bottom" style="margin: 0px;">
                            <a v-if="isFullscreen" @click="buttoncli">
                                <svg t="1685682630584" class="icon headers-right-left-screenIcon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4190" width="200" height="200"><path d="M384.32 597.312c23.36 0 42.368 19.2 42.368 42.752v256.448c0 23.552-19.392 42.24-42.816 42.24a41.792 41.792 0 0 1-41.92-42.24v-156.736l-227.008 228.992a42.048 42.048 0 0 1-59.84 0 43.008 43.008 0 0 1 0-60.416l223.36-225.536h-151.04a42.368 42.368 0 0 1-42.112-42.752c0-23.616 18.816-42.752 42.24-42.752z m512.192 0c23.36 0 42.24 19.2 42.24 42.752a42.368 42.368 0 0 1-42.176 42.752h-151.04l223.36 225.536a43.008 43.008 0 0 1 0 60.416 42.048 42.048 0 0 1-59.84 0l-227.008-228.992v156.736c0 23.552-18.56 42.24-41.92 42.24a42.496 42.496 0 0 1-42.816-42.24V640c0-23.616 19.008-42.752 42.368-42.752h256.832zM114.944 55.232L341.952 284.16V127.488c0-23.552 18.56-42.24 41.92-42.24 23.424 0 42.816 18.688 42.816 42.24V384a42.56 42.56 0 0 1-42.368 42.752H127.488c-23.36 0-42.24-19.2-42.24-42.752 0-23.68 18.752-42.752 42.176-42.752h151.04L55.168 115.648a43.008 43.008 0 0 1 0-60.416 42.048 42.048 0 0 1 59.84 0z m794.112 0a42.048 42.048 0 0 1 59.84 0 43.008 43.008 0 0 1 0 60.416L745.6 341.12h151.04c23.424 0 42.112 19.136 42.112 42.752a42.432 42.432 0 0 1-42.24 42.752H639.744a42.56 42.56 0 0 1-42.368-42.752V127.488c0-23.552 19.392-42.24 42.816-42.24 23.36 0 41.92 18.688 41.92 42.24v156.736z" fill="#ffffff" p-id="4191"></path></svg>
                            </a>
                            <a v-else @click="buttoncli">
                                <svg t="1685682180150" class="icon headers-right-left-screenIcon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2753" width="200" height="200"><path d="M131.413333 85.333333h142.933334a32 32 0 1 0 0-64H54.186667a32 32 0 0 0-32 32v221.013334a32 32 0 1 0 64 0V131.413333l344.32 344.32a32 32 0 0 0 45.226666-45.226666zM969.813333 717.653333a32 32 0 0 0-32 32v142.506667l-344.32-344.32a32 32 0 0 0-45.226666 45.226667l344.32 345.6h-142.933334a32 32 0 0 0 0 64h220.16a32 32 0 0 0 32-32v-221.013334a32 32 0 0 0-32-32zM999.253333 42.666667a32 32 0 0 0-29.44-19.626667h-220.16a32 32 0 1 0 0 64h142.506667l-344.32 344.32a32 32 0 1 0 45.226667 45.226667L938.666667 131.413333v142.933334a32 32 0 1 0 64 0V54.186667a32 32 0 0 0-3.413334-11.52zM430.506667 548.266667L85.333333 892.586667v-142.933334a32 32 0 1 0-64 0v220.16a32 32 0 0 0 32 32h221.013334a32 32 0 1 0 0-64H131.413333l344.32-344.32a32 32 0 0 0-45.226666-45.226666z" fill="#ffffff" p-id="2754"></path></svg>
                            </a>
                        </el-tooltip>
                    </el-menu-item>

                    <el-menu-item class="site-navbar__avatar">
                        <el-dropdown :show-timeout="0">
                        <span class="el-dropdown-link">
                            <span style="color: white;font-size: 15px;margin-right: 5px;">
                                <!--<i class="el-icon-office-building"></i>-->[账套：{{currZtName}}]</span>
                            <span style="margin-left: 5px;font-size: 15px;color: white;margin-right: 10px;">{{currZtDate}}</span>
                            <img style="width: 26px;border-radius: 0%" src="~@/assets/img/ntx.png">
                        </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="$router.push({ name: 'home' })">账套切换<i
                                        class="el-icon-sort"></i></el-dropdown-item>
                                <el-dropdown-item @click.native="editUserInfo()">用户信息<i
                                        class="el-icon-edit-outline"></i></el-dropdown-item>
                                <el-dropdown-item @click.native="logoutHandle()">退出登录<i class="el-icon-s-promotion"></i>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-menu-item>
                </el-menu>
            </div>
        </nav>
        <infoEdit v-if="editVisible" ref="infoEdit"></infoEdit>
    </div>
</template>
<script>
    // 全屏组件
    import screenfull from 'screenfull'
    import MainSidebar from './main-sidebar'
    import InfoEdit from "./modules/home/system/user/infoEdit"

    export default {
        data() {
            return {
                editVisible: false,
                isFullscreen: false,
                messageFlag: false
            }
        },
        components: {
            MainSidebar,
            InfoEdit
        },
        created() {

        },
        computed: {
            navbarLayoutType: {
                get() {
                    return this.$store.state.common.navbarLayoutType
                }
            },
            sidebarFold: {
                get() {
                    return this.$store.state.common.sidebarFold
                },
                set(val) {
                    this.$store.commit('common/updateSidebarFold', val)
                }
            },
            mainTabs: {
                get() {
                    return this.$store.state.common.mainTabs
                },
                set(val) {
                    this.$store.commit('common/updateMainTabs', val)
                }
            },
            currZtName: {
                get() {
                    return localStorage.getItem('CURR_ZT_NAME');
                }
            },
            currZtDate: {
                get() {
                    return localStorage.getItem('CURR_ZT_DATE');
                }
            }
        },
        methods: {
            // 全屏
            buttoncli(){
                screenfull.toggle()
                this.checkFull()
            },
            // 监控屏幕变化
            checkFull() {
                var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;
                // 是否全屏判断
                this.isFullscreen = !this.isFullscreen;
                if (isFull === undefined) {
                    isFull = false;
                }
                return isFull;
            },
            editUserInfo() {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.infoEdit.int();
                })
            },
            onlineLogout() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl("/business/logout"),
                    method: 'post'
                }).then(r => {
                    if (r.data.code == 0) {

                        localStorage.removeItem("menus")
                        localStorage.removeItem("menuList")
                        localStorage.removeItem('permissionSet')
                        localStorage.removeItem('user_token')

                        localStorage.removeItem('CURR_ZT_ID');
                        localStorage.removeItem('CURR_ZT_NAME');
                        localStorage.removeItem('CURR_ZT_DATE');

                        this.$router.push('/login') //成功跳转到首页
                    }
                })
            },
            // 退出
            logoutHandle() {
                this.$confirm(`确定进行[退出]操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.onlineLogout()
                }).catch(() => {
                })
            },
            openMessage() {


            }

        }
    }
</script>
<style scoped>
    .el-dropdown-link img {
        margin-bottom: 6px;
    }

    .el-menu-item, .el-submenu__title {
        padding: 0 5px !important;
    }

    .el-menu-item:focus, .el-menu-item:hover {
        background-color: #35435f !important;
        cursor: pointer !important;
    }
    .headers-right-left-screenIcon{
        width: 20px;
        height: 20px;
        padding-bottom: 5px;
    }
</style>